<template>
  <div class = "heads">
    <div class = "big-center">
      <div class = "center">
        <div style="text-align: center; padding: 30px 0;">
           <div style="margin-bottom: 20px;">
						<a href="javascript:void(0)" @click="goToGuide(249)" style="color: #fff; text-decoration: none; margin: 0 10px;">关于我们</a>
						<a href="javascript:void(0)" @click="goToGuide(250)" style="color: #fff; text-decoration: none; margin: 0 10px;">用户指南</a>
						<a href="javascript:void(0)" @click="goToGuide(251)" style="color: #fff; text-decoration: none; margin: 0 10px;">国际运费</a>
						<a href="javascript:void(0)" @click="goToGuide(252)" style="color: #fff; text-decoration: none; margin: 0 10px;">海关与关税</a>
						<a href="javascript:void(0)" @click="goToGuide(246)" style="color: #fff; text-decoration: none; margin: 0 10px;">隐私政策</a>
						<a href="javascript:void(0)" @click="goToGuide(253)" style="color: #fff; text-decoration: none; margin: 0 10px;">服务条款</a>
						<a href="javascript:void(0)" @click="goToGuide(254)" style="color: #fff; text-decoration: none; margin: 0 10px;">基于特定交易法表示</a>
						<a href="javascript:void(0)" @click="goToGuide(255)" style="color: #fff; text-decoration: none; margin: 0 10px;">常见问题</a>
						<a href="javascript:void(0)"  style="color: #fff; text-decoration: none; margin: 0 10px;">申请商品调查</a>
						<a href="javascript:void(0)"  style="color: #fff; text-decoration: none; margin: 0 10px;">咨询</a>
					</div>
          <div style="font-size: 20px; margin-bottom: 10px;">九条购</div>
          <div style="font-size: 12px;">copyright (c) 九条购 all rights reserved.</div>
        </div>
      </div>
    </div>
	<section class = "copyright-section">
		<a href = "http://www.beian.gov.cn/">
			<p>{{beianhao}}</p>
		</a>
	</section>
  </div>
</template>

<script>
export default {
		name: 'Foots',
		data() {
			return {
				QRcode: '../assets/foot/xcx.png',
				downcode: '../assets/foot/app.png',
				company: '臻逸國際有限公司',
				address: 'Unit 903D, 9/F., Cameron Commercial Centre,458-468 Hennessy Road,Causeway Bay,Hong Kong',
				weixin: 'maxdlln',
				beianhao: '',
				version:'zh'
			}
		},
			created() {
			this.getCode()
			var version = this.version
			setInterval(() => {
				version = this.$cookie.get('language')
				if(version!=this.version){
					this.version = version
				}
			}, 1000)
		},
		methods: {
		// 修改foots.vue文件中的goToGuide方法
goToGuide(type) {
  console.log('goToGuide called with type:', type);
  // 调用接口获取内容
  this.$http({
    url: this.$http.adornUrl('/common/type/' + type),
    method: 'get',
    params: this.$http.adornParams({}),
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    }
}).then(({ data }) => {
					console.log('api response:', data);
					console.log('api response data:', data.data);
					if (data && data.status === 0) {
      // 检查当前是否已经在购物须知页面
      if (this.$route.path === '/shoppingGuide') {
        // 如果已经在购物须知页面，直接更新路由参数
        this.$router.replace({
          path: '/shoppingGuide',
          query: { 
            content: encodeURIComponent(data.data.value),
            type: type
          }
        })
      } else {
        // 跳转到购物须知页面，并传递获取的内容
        this.$router.push({
          path: '/shoppingGuide',
          query: { 
            content: encodeURIComponent(data.data.value),
            type: type
          }
        })
      }
    } else {
      // 如果获取失败，仍然跳转到购物须知页面
      this.$router.push('/shoppingGuide')
    }
  }).catch((error) => {
    console.log('api error:', error);
    // 网络错误时，仍然跳转到购物须知页面
    this.$router.push('/shoppingGuide')
  })
},
			goAbute(url) {
				console.log('url', url)
				uni.navigateTo({
					url: url
				})
			},
			getCode() {
				this.$http({
					url: this.$http.adornUrl('/common/type/280'),	//小程序二维码
					method: 'get',
				}).then(({data}) => {
					
					if(data.data){
						window.localStorage.setItem("QRcode",data.data.value);
						this.QRcode = data.data.value
					}
					
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/281'),	//app下载地址
					method: 'get',
				}).then(({data}) => {
					window.localStorage.setItem("downcode",data.data.value);
					this.downcode = data.data.value
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/282'),	//公司名称
					method: 'get',
				}).then(({data}) => {
					this.company = data.data.value
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/283'),	//公司地址
					method: 'get',
				}).then(({data}) => {
					this.address = data.data.value
				})

			this.$http({
					url: this.$http.adornUrl('/common/type/284'),	//备案号
					method: 'get',
				}).then(({data}) => {
					this.beianhao = data.data.value
				})
			this.$http({
					url: this.$http.adornUrl('/common/type/44'),	//微信号
					method: 'get',
				}).then(({data}) => {
					this.weixin = data.data.value
			})
		}

	}
}
</script>
<style scoped = "scoped">
.big-center {
	width: 100%;
	line-height: 24px;
	color: #fff;
	font-size: 14px;
	background: #000;
}

.center {
	width: 1200px;
	margin: 0 auto;
}

.cont {
	display: inline-block;
	font-size: 14px;
	vertical-align: top;
	
}

.left {
	width: 25%;
	text-align: left;
}

.left img {
	width: 82%;
	position: relative;
	top: 14px;
}

.conter {
	text-align: left;
	width: 50%;
	line-height: 40px;
}

.names {
	font-size: 20px;
}

.right {
	width: 24%;
	/* padding-top: 5%; */


}

.right .xcx {
	display: inline-block;
	text-align: center;
	/* width: 40%; */
	margin-left: 9%;
	/* padding: 2% 10%; */
}

.right .xcx img {
	width: 40%;

}

.saoma {
	text-align: center;
}

.copyright-section {
	background: #fff;
}

.copyright-section p {
	color: #999999;
}

.copyright-section p span {
	color: #cccccc;
}

.copyright-section {
	padding: 30px 0;
	text-align: center;
	background: #000000;
}

.copyright-section p {
	margin-bottom: 0;
	font-size: 10px;
	text-transform: uppercase;
	color: #999;
	font-family: 'Montserrat', sans-serif;
}

.copyright-section p span {
	color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/foots.vue